import React, { useState, useEffect } from 'react';
import Main_Spring from '../component/Spring/Main_Spring';
import Info_Spring from '../component/Spring/Info_Spring';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import axios from 'axios';
import Save_Date from '../component/Save_Date';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import AccountList from '../component/Account/AccountList';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import Interview_Spring from '../component/Spring/Interview_Spring';

const LimSuBin2 = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);
    
    const openTitle = "이승우 ❤️ 임수빈, 저희 결혼합니다.";
    const openDesc = "4월 19일 오후 6시 50분";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/56/thumb.jpg";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen:''
    });

    const conceptStyle = {
        // spring 퍼플
        concept: "SPRING",
        titleColor: "#bf9cd8",
        pointColor: "#bf9cd8",
        btnBgColor: "#e4d0f7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#f8f3ff",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const groomAccountList = [
        {
            role: "신랑",
            name: "이승우",
            bank: "우리은행",
            accountNumber : "1002-062-744371",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7vaLeDy"
        }
    ]
    const brideAccountList = [
        {
            role: "신부",
            name: "임수빈",
            bank: "카카오뱅크",
            accountNumber : "3333-06-7464767",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej9ErYOvp"
        },
        {
            role: "신부 모",
            name: "최경옥",
            bank: "국민은행",
            accountNumber : "024801-04-236020",
            isKakao : false
        }
    ]
    
    const msg1 = "@승@낙없이 계절을 따라 피는 봄날, \n@우@연한 만남을 시작으로 \n@수@많은 날을 함께하며\n@빈@틈없이 서로를 채워가는 행복한 여정을 시작합니다.";
    const msg2 = "오랜 기다림 속에 저희 두사람, 결혼을 합니다. \n소중한 시작이 될 수 있도록 \n오셔서 지켜봐주시면 감사하겠습니다.";

    const lng = 126.9755383;
    const lat = 37.5367693;
    
    const placeTelNum = "02-793-2900";

    const forCar = "① 한강대교에서 오시는 경우\n- 서울역 방면으로 오셔서 삼각지역 사거리를 지나서 \n북문으로 우회전 진입\n② 서울역에서 오시는 경우\n- 한강대교 방면으로 오셔서 삼각지역 사거리에서 좌회전 \n후 70M 전방에서 서문으로 좌회전 진입\n③ 이태원방면에서 오시는 경우 \n- 삼각지역 사거리 방향으로 오시다가 동문으로 우회전 \n진입 \n④ 마포(공덕역)에서 오시는 경우\n- 삼각지 고가차도를 넘어 삼각지역 사거리에서 직진 후 \n70M 전방에서 서문으로 좌회전 진입 ";
    const forBus = "① 마을버스\n- 용산03 (전쟁기념관 하차)\n② 간선버스(전쟁기념관 하차)\n- 110A, 110B, 421, 740, N72. N75\n③ 삼각지역 하차\n- 421, N75, 100, 150, 151, 152, 500, 501, 502, 504, \n506, 507, 605, 742, 750A, 750B, 752, N15";
    const forSubway = "① 6호선 : 삼각지역 12번 출구 (도보 3분)\n② 4호선 : 삼각지역 1번 출구 (도보 5분)\n③ 1호선 : 남영역 1번 출구 (도보 7분)";
    const forParking = " - 전쟁기념관내 지상, 지하 주차 가능\n- 지상, 지하 주차 1000대 가능\n- 1층 로비 내 태블릿 이용하여 주차권 사전등록 필요 \n(2시간 무료)";

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "잊지 못할 날",
            brideAnswer: "한번뿐인 날"
        },
        {
            question : "서로에게 반한 이유는?",
            groomAnswer: "운명 같아서",
            brideAnswer: "딱! 곰돌이 푸"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "늘 함께하자",
            brideAnswer: "늘 사랑하자"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "말을 잘 듣자!",
            brideAnswer: "그만 혼내자!"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "많이많이♥️"
        }
    ]
    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();
    }, []);

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);


    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    if (!weddingData || !conceptStyle) return <Loading color={weddingData.pointColor}/>;
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#bf9cd8"} loading={loading} />
            ) : (
            <>
            <Music concept={conceptStyle.concept}/>
            <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
            <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
            <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
            <Letter title={"오랜 기다림 속에 저희 두사람, 결혼을 합니다."} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle}/>
            <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                <MotionWrapper initialY={50}>
                <GalleryList color={conceptStyle.pointColor} weddingData={weddingData} initCount={6} photoWidth={"153px"} photoHeight={"235px"} gap={"3px"}/>
                    <MotionWrapper initialY={70}>
                    <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                        <MotionWrapper initialY={70}>
                            <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} conceptStyle={conceptStyle} btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.pointColor}/>
                            <MotionWrapper initialY={50}>
                                <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                                <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                <Location_Desc forParking={forParking} forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                                <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                <Footer />
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </MotionWrapper>
            </>
            )}
        </div>
    );
};

export default LimSuBin2;
